import Service, { inject as service } from '@ember/service';
import EObject from '@ember/object';

export default class CapitalEngineContextService extends Service {
  @service cookies;
  @service currentApplicationFlow;
  @service sfsCustomerApi;

  /**
   * Pulls CSRF token from JS cookie and adds it to X-CSRF-Token
   */
  get headers() {
    return {
      'X-CSRF-Token': this.cookies.read('_js_csrf'),
      'X-MULTIPASS-SESSION-SCOPE': 'square',
    };
  }

  get sessionContext() {
    return this._sessionContext;
  }

  set sessionContext(data) {
    this._sessionContext = data;
  }

  get localeContext() {
    return EObject.create({
      languageCode: 'en-US',
      countryCode: 'US',
      useAsyncTranslations: false,
      translationsPath: '',
      defaultTranslationsPath: '',
    });
  }

  async fetchCurrentApplicationFlow() {
    const { customer } = await this.sfsCustomerApi.retrieveCustomer();

    // If the customer has an application flow, go ahead and fetch the whole thing now
    // so it will be cached in currentApplicationFlow for other signup routes.
    if (customer.applicationFlows.length > 0) {
      const { id } = customer.applicationFlows[0];
      return this.currentApplicationFlow.retrieve(id);
    } else {
      return null;
    }
  }

  async fetchLoggedInUser() {
    const applicationFlow =
      this.currentApplicationFlow.get() ||
      (await this.fetchCurrentApplicationFlow());
    const firstName =
      (applicationFlow &&
        applicationFlow.individual &&
        applicationFlow.individual.givenName) ||
      '';
    return EObject.create({ firstName });
  }
}
